
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.75 14.5c-.744 0-1.418.297-1.914.777l-6.844-3.125c.003-.051.008-.1.008-.152 0-.052-.005-.102-.008-.152l6.844-3.125A2.75 2.75 0 1015 6.75c0 .052.005.102.008.152l-6.844 3.125a2.75 2.75 0 100 3.946l6.844 3.125c-.003.05-.008.1-.008.152a2.75 2.75 0 102.75-2.75z","fill":"currentColor"}})])
          )
        }
      }
    